import React from "react";
import styles from "./index.module.scss";
import type { Transaction } from "@/types/bridge-scanner.types";

type Props = {
  text: string | undefined;
};

const Chip = ({ text }: Props) => {
  if (text) return <div className={styles.type}>{text}</div>;
};

export default Chip;
